import React from 'react';

import { useStyles } from './styles';
import { limitText } from 'utils/limitText';
import { IReturnReceiptReasonsCellProps } from './interfaces';

export const ReturnReceiptReasonsCell = ({ row }: IReturnReceiptReasonsCellProps) => {
  const classes = useStyles();
  const returnReceiptReasonsDescription = row?.returnReceiptReasons?.map((item) => item.reasonDescription);
  const returnReceiptReasonsDescriptionString = returnReceiptReasonsDescription.join('\n');
  const returnReceiptReasonsDescriptionLimited = limitText(returnReceiptReasonsDescriptionString, 150);

  return <div className={classes.container}>{returnReceiptReasonsDescriptionLimited}</div>;
};
